import React from 'react';
import { useDispatch } from 'react-redux';
import { Button, Modal } from 'antd';
import { confirmArchive, confirmRestoreArchive } from '../popup/confirm';
import { updateVehicleStatus } from '../../../redux/actions/vehicleCard';

const confirm = Modal.confirm;

const BtnArchive = ({ isArchive, vehicleId, disabled }) => {
  const dispatch = useDispatch();
  const confirmPopup = () => {
    confirm({
      ...(isArchive ? confirmRestoreArchive : confirmArchive),
      onOk: cencel => {
        cencel();
        dispatch(
          updateVehicleStatus({
            vehicleId,
            status: isArchive ? 1 : 2,
          })
        );
      },
    });
  };

  if (isArchive) {
    return (
      <Button 
        type="primary" 
        size="large" 
        onClick={confirmPopup}
        disabled={disabled}
      >
        Восстановить ТС
      </Button>
    );
  } else {
    return (
      <Button
        className="orders-create__edit-btn"
        type="danger"
        ghost
        size="large"
        onClick={confirmPopup}
        disabled={disabled}
      >
        Архивировать ТС
      </Button>
    );
  }
};

export default BtnArchive;
